import React, { ReactNode } from 'react';

import PrimaryCard from './PrimaryCard/PrimaryCard';
import SecondaryCard from './SecondaryCard/SecondaryCard';

import styles from './EmptyState.module.css';

interface OnboardingEmptyStateProps {
  children: ReactNode;
  title: string;
  description: string;
  asset: ReactNode;
}

export const OnboardingEmptyState: React.FC<OnboardingEmptyStateProps> & {
  PrimaryCard: typeof PrimaryCard;
  SecondaryCard: typeof SecondaryCard;
} = ({ children, title, description, asset }) => {
  return (
    <div className={styles.container}>
      <div className={styles.children}>
        <h5 className="mb-1">{title}</h5>
        <p className="mb-4">{description}</p>
        <div className={styles.cards}>{children}</div>
      </div>
      <div className={styles.asset}>{asset}</div>
    </div>
  );
};

OnboardingEmptyState.PrimaryCard = PrimaryCard;
OnboardingEmptyState.SecondaryCard = SecondaryCard;
